import { ApplicationMuiTheme } from 'Lib/themes/muiTheme';

export const muiStyles = (theme: ApplicationMuiTheme) => {
    return ({
        dashboard: {
            height: 'calc(100vh - 65px)',
            overflowY: 'auto' as const
        },
        dashboardHeaderContainer: {
            flexBasis: 'auto' as const,
            margin: '8px 0 16px 0'
        },
        dashboardUpdatedText: {
            color: theme?.app?.clientTheme.colors.primaryColor ||
                '#375073',
            margin: '0rem 0 0rem 2rem',
            textTransform: 'uppercase' as const,
            [theme.breakpoints.down('md')]: { marginTop: '3rem' }
        },
        tableContainer: {
            flexBasis: 'auto' as const,
            flexGrow: 0,
            padding: '0 22px',
            marginBottom: '16px'
        },
        kpis: { padding: '1.5rem 1rem' },
        dashboardFooter: {
            padding: '0 22px',
            flexGrow: 0.9,
            color: theme?.app?.applicationColors.fontDetailColor ||
                '#4A4C50'
        },
        killSwitchMessage: {
            fontSize: '1.1rem',
            fontWeight: 'bold' as const,
            color: theme?.app?.applicationColors.lockColor ||
                '#F5824A'
        },
        footerLogoContainer: { width: 'fit-content' },
        footerLogo: {
            height: '22px',
            margin: '0 8px'
        },
        tzeroInfoIconContainer: {
            height: '18px',
            alignSelf: 'center' as const
        },
        tzeroInfoIcon: {
            cursor: 'pointer' as const,
            height: '18px',
            width: '18px'
        },
        centerLogo: {
            width: 'auto',
            margin: '0 auto'
        },
        balancesContainer: {
            backgroundColor: theme?.app?.applicationColors.backgroundPrimary ||
                '#FFFFFF'
        }
    });
};